<template>
  <tr class="SearchResultRow">
    <td class="no-wrap" scope="row">
      <span
        class="pf-table-icon mr-2"
        title="Program Information"
        @click="toggleProgramInfo"
      >
        <button type="button" class="icoLink link p-0" aria-label="View program information">
          <i class="fas fa-info fa-border mr-1" aria-hidden="true"></i>
        </button>
      </span>

      <span
        class="pf-table-icon mr-2"
        title="Rate Information"
        @click="toggleRateInfo"
      >
        <button type="button" class="icoLink link p-0" aria-label="View rate information">
          <i class="fas fa-dollar-sign fa-border mr-1" aria-hidden="true"></i>
        </button>
      </span>

      <span
        class="pf-table-icon mr-2"
        title="Calendar Information"
        @click="toggleCalendarInfo"
      >
        <button type="button" class="icoLink link p-0" aria-label="View calendar information">
          <i class="far fa-calendar-alt" aria-hidden="true"></i>
        </button>
      </span>
    </td>
    <td>{{ SearchResult.ProgramCode }}</td>
    <td v-if="ShowName">
      <router-link
        v-bind:to="FacilityDisplayLink"
        target="_blank"
        class="row Program"
        title="open in new tab"
      >
        <span class="">
          <!-- data-toggle="tooltip" data-placement="bottom"> -->
          {{ SearchResult.ProgramName }}
        </span>
        <span class="hide ml-2"
          ><i
            class="fas fa-external-link-alt mr-1 fa-xs"
            title="open in new tab"
          ></i
        ></span>
      </router-link>

      <!-- <a href="#" target="_blank"> {{ SearchResult.ProgramName }}</a> -->
    </td>
    <td>{{ SearchResult.FacilityTypeDescription }}</td>
    <td>
      <a v-bind:href="GoogleAddress" target="_blank">
        <i class="fas fa-map-marker-alt"></i>
        {{ SearchResult.ProgramAddress }}</a
      >
    </td>
  </tr>

  <tr v-if="ShowDetailsRow" class="SearchResultRow">
    <td></td>
    <td colspan="4">
      <div class="pl-1 pt-1 pb-1 pr-5" v-if="ShowProgramInformation">
        <div class="card mb-3">
          <div class="card-header pf-nested-card-header font-weight-bold">
            Program Information
          </div>
          <div class="card-body px-4 pt-3 pb-0">
            <table
              id="ProgInfoTable"
              class="pf-table"
              style="border-collapse: collapse"
            >
              <thead>
                <tr>
                  <th>
                    <span
                      class="font-weight-bold"
                      style="padding: 0px !important"
                      >Public/Private</span
                    >
                  </th>
                  <th>
                    <span
                      class="font-weight-bold"
                      style="padding: 0px !important"
                      >Location Type</span
                    >
                  </th>
                  <th>
                    <span
                      class="font-weight-bold"
                      style="padding: 0px !important"
                      >Program Type</span
                    >
                  </th>
                  <th>
                    <span
                      class="font-weight-bold"
                      style="padding: 0px !important"
                      >Limited Approval</span
                    >
                  </th>
                  <th>
                    <span
                      class="font-weight-bold"
                      style="padding: 0px !important"
                      >Add On Type</span
                    >
                  </th>
                  <th>
                    <span
                      class="font-weight-bold"
                      style="padding: 0px !important"
                      >Gender</span
                    >
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="padding-top: 2px !important">
                    {{ Program.EntityTypeDescription }}
                  </td>
                  <td style="padding-top: 2px !important">
                    {{ Program.LocationTypeDescription }}
                  </td>
                  <td
                    style="padding-top: 2px !important; margin: 0px !important"
                  >
                    {{ Program.FacilityTypeDescription }}
                  </td>
                  <td style="padding-top: 2px !important">
                    {{ LimitedApprova }}
                  </td>
                  <td style="padding-top: 2px !important">
                    {{ Program.AddOnTypeDescription }}
                  </td>
                  <td style="padding-top: 2px !important">
                    {{ Program.GenderType }}
                  </td>
                </tr>
                <tr>
                  <td
                    style="padding-top: 2px !important"
                    class="pf-no-border p-3"
                    colspan="6"
                  >
                    <div class="flex-grow-1 pf-ghost-div px-4 pb-2 pt-2 m-3">
                      <span class="font-weight-bold">Disabilities Served</span>
                      <table
                        class="pf-table small"
                        style="empty-cells: hide !important"
                      >
                        <thead>
                          <tr>
                            <th>
                              <span
                                class="font-weight-bold"
                                style="padding: 0px !important"
                                >Disability</span
                              >
                            </th>
                            <th>
                              <span
                                class="font-weight-bold"
                                style="padding: 0px !important"
                                >Low Age</span
                              >
                            </th>
                            <th>
                              <span
                                class="font-weight-bold"
                                style="padding: 0px !important"
                                >High Age</span
                              >
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in Disabilities"
                            :key="item.DisabilityId"
                          >
                            <td style="padding-top: 2px !important">
                              {{ item.Description }}
                            </td>
                            <td style="padding-top: 2px !important">
                              {{ item.LowAge }}
                            </td>
                            <td style="padding-top: 2px !important">
                              {{ item.HighAge }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              v-if="IsAllowPast22 != ''"
              class="pf-table"
              style="border-collapse: collapse"
            >
              <thead>
                <tr>
                  <th>
                    <span class="font-weight-bold">Allow Past Age 22 - <cite>For educational programming only</cite> :</span>
                    {{ IsAllowPast22 }}
                  </th>
                </tr>
              </thead>
            </table>

            <!-- <div class="ml-3 mb-3" v-if="IsAllowPast22 != ''">
              <span class="font-weight-bold">Allow past age 22 :</span>
              {{ IsAllowPast22 }}
            </div> -->
            <table
       id="ProgInfoTable"
       class="pf-table"
       style="border-collapse: collapse"
     >
       <thead>
         <tr>
           <th>
             <span
               class="font-weight-bold"
               style="padding: 0px !important"
               >ISBE Reviewer : </span> <span class="font-weight-normal">{{ Program.AssignedConsultant }}</span>
           </th>             
         </tr>         
       </thead>      
     </table>
    
              
          </div>
        </div>
      </div>

      <div class="pl-1 pt-1 pb-1 pr-5" v-if="ShowRateInformation">
        <div class="card mb-3">
          <div class="card-header pf-nested-card-header font-weight-bold">
            Rate Information
          </div>

          <div class="card-body px-4 pt-3 pb-0">
            <div v-if="RnBRates.length > 0">
              <div class="flex-grow-1 pf-ghost-div px-4 pb-2 pt-2 m-3">
                <span class="font-weight-bold">Room and Board</span>
                <table
                  class="pf-table small"
                  style="empty-cells: hide !important"
                >
                  <thead>
                    <tr>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Begin</span
                        >
                      </th>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >End</span
                        >
                      </th>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Days</span
                        >
                      </th>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Per Diem</span
                        >
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in RnBRates" :key="item.RatesId">
                      <td style="padding-top: 2px !important">
                        {{ FormattedDate(item.BeginDate) }}
                      </td>
                      <td style="padding-top: 2px !important">
                        {{ FormattedDate(item.EndDate) }}
                      </td>
                      <td style="padding-top: 2px !important">
                        {{ item.Days }}
                      </td>
                      <td style="padding-top: 2px !important">
                        ${{ item.CostPerDay }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="mt-2" v-if="TuitionRates.length > 0">
              <div class="flex-grow-1 pf-ghost-div px-4 pb-2 pt-2 m-3">
                <span class="font-weight-bold">Tuition Rates</span>
                <table
                  class="pf-table small"
                  style="empty-cells: hide !important"
                >
                  <thead>
                    <tr>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Begin Date</span
                        >
                      </th>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >End Date</span
                        >
                      </th>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Days</span
                        >
                      </th>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Per Diem</span
                        >
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in TuitionRates" :key="item.RatesId">
                      <td style="padding-top: 2px !important">
                        {{ FormattedDate(item.BeginDate) }}
                      </td>
                      <td style="padding-top: 2px !important">
                        {{ FormattedDate(item.EndDate) }}
                      </td>
                      <td style="padding-top: 2px !important">
                        {{ item.Days }}
                      </td>
                      <td style="padding-top: 2px !important">
                        ${{ item.CostPerDay }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pl-1 pt-1 pb-1 pr-5" v-if="ShowCalendarInformation">
        <div class="card">
          <div class="card-header pf-nested-card-header font-weight-bold">
            Calendar Information

            <span class="float-right">
              <button
                type="button"
                class="icoLink link p-0"
                @click="toggleCalendarInfo"
                title="Close Calendar Information"
              >
                <i class="fas fa-times"></i> close
              </button>
            </span>
          </div>

          <div class="card-body px-4 pt-3 pb-0">
            <div class="m-3" v-if="ApprovedCalendar != ''">
              Approved on :
              {{ ApprovedCalendar }}
            </div>
          </div>

          <div class="card-body px-4 pt-0 pb-0">
            <div class="flex-grow-1 pf-ghost-div px-4 pb-2 pt-2 m-3">
              <span class="font-weight-bold">Days Approved</span>
              <span class="font-weight-bold float-right" v-if="IsSchoolCalendarAvailable">
                  <a v-bind:href="ElectronicCalendarLink" target="_blank"><i class="fas fa-calendar-alt"></i> Electronic Calendar</a>
                </span>

              <div v-if="CalendarDates.length == 0" class="text-muted">
                No data on file
              </div>

              <table
                class="pf-table small"
                style="empty-cells: hide !important"
                v-else
              >
                <thead>
                  <tr>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Regular Begin Date</span
                      >
                    </th>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Regular End Date</span
                      >
                    </th>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Total Regular Days</span
                      >
                    </th>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Summer Begin Date</span
                      >
                    </th>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Summer End Date</span
                      >
                    </th>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Total Summer Days</span
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="padding-top: 2px !important">
                      {{ RegularBeginDate_Reimbursement }}
                    </td>
                    <td style="padding-top: 2px !important">
                      {{ RegularEndDate_Reimbursement }}
                    </td>
                    <td style="padding-top: 2px !important">
                      {{ TotalApprovedRegularDays }}
                    </td>
                    <td style="padding-top: 2px !important">
                      {{ SummerBeginDate_Reimbursement }}
                    </td>
                    <td style="padding-top: 2px !important">
                      {{ SummerEndDate_Reimbursement }}
                    </td>
                    <td style="padding-top: 2px !important">
                      {{ TotalApprovedSummerDays }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import moment from "moment";
import Constants from "../utilities/Constants.js";

export default {
  name: "SearchResult",
  data() {
    return {
      ShowProgramInformation: false,
      ShowRateInformation: false,
      ShowCalendarInformation: false,
      Program: [],
      Disabilities: [],
      Rates: [],
      RnBRates: [],
      TuitionRates: [],
      CalendarDates: [],
      TotalRegularDays: 0,
      TotalSummerDays: 0,
      TotalApprovedRegularDays: 0,
      TotalApprovedSummerDays: 0,
      CalendarApprovedDate: "",
      IsSchoolCalendarAvailable: false,
    };
  },
  props: {
    SearchResult: {
      type: Object,
      required: true,
    },
    ShowName: {
      type: Boolean,
      requied: true,
    },
  },
  methods: {
    toggleProgramInfo() {
      this.ShowProgramInformation = !this.ShowProgramInformation;
      if (this.ShowProgramInformation) {
        this.getProgramInfo();
      }
    },

    getProgramInfo() {
      const ProgramDetailsURL = `${Constants.API_URL}/api/PFSearchAPI/GetPFSearchProgramInfoAsync?ProgramEntityId=${this.SearchResult.ProgramCode}&schoolYear=${this.SearchResult.SchoolYear}`;

      //console.log(`Getting Intialisation data from : ${ProgramDetailsURL}`);

      const cache = localStorage.getItem(ProgramDetailsURL);
      let o;
      if (cache) {
        o = JSON.parse(cache);
      }

      if (o && Date.now() <= o.expires) {
        this.SetupProgramData(o.data);

        // console.log(o.data);
      } else {
        //console.log("getting data from web");

        fetch(ProgramDetailsURL)
          .then((response) => response.json())
          .then((data) => {
            //   console.log(data);

            this.SetupProgramData(data);

            localStorage.setItem(
              ProgramDetailsURL,
              JSON.stringify({
                expires: Date.now() + 60 * 60 * 24 * 1000, // Cache for 24 hours
                data: data,
              })
            );
          });
      }
    },
    SetupProgramData(data) {
      this.Program = data;
      this.Disabilities = data.Disabilities;
    },

    toggleRateInfo() {
      this.ShowRateInformation = !this.ShowRateInformation;
      if (this.ShowRateInformation) {
        this.getRateInfo();
      }
    },

    getRateInfo() {
      const RateDetailsURL = `${Constants.API_URL}/api/PFSearchAPI/GetPFSearchRatesInfoAsync?ProgramEntityId=${this.SearchResult.ProgramCode}&schoolYear=${this.SearchResult.SchoolYear}`;

      //https://apps.isbe.net/SEPF_WebApi/api/PFSearchAPI/GetPFSearchRatesInfoAsync?ProgramCode=13791&schoolYear=2020

      //console.log(`Getting Intialisation data from : ${RateDetailsURL}`);

      const cache = localStorage.getItem(RateDetailsURL);
      let o;
      if (cache) {
        o = JSON.parse(cache);
      }

      if (o && Date.now() <= o.expires) {
        this.SetupRateData(o.data);

        // console.log(o.data);
      } else {
        //console.log("getting data from web");

        fetch(RateDetailsURL)
          .then((response) => response.json())
          .then((data) => {
            // console.log(data);

            this.SetupRateData(data);

            localStorage.setItem(
              RateDetailsURL,
              JSON.stringify({
                expires: Date.now() + 60 * 60 * 24 * 1000, // Cache for 24 hours
                data: data,
              })
            );
          });
      }
    },
    SetupRateData(data) {
      this.Rates = data;
      this.RnBRates = this.Rates.filter(function (rate) {
        return rate.RateTypeId == 1;
      });
      this.TuitionRates = this.Rates.filter(function (rate) {
        return rate.RateTypeId == 2;
      });
    },
    ////

    getCalendarInfo() {
      const CalDetailsURL = `${Constants.API_URL}/api/PFSearchAPI/GetPFSearchCalendarInfoAsync?ProgramEntityId=${this.SearchResult.ProgramCode}&schoolYear=${this.SearchResult.SchoolYear}`;

      //https://apps.isbe.net/SEPF_WebApi/api/PFSearchAPI/GetPFSearchCalendarInfoAsync?ProgramCode=13791&schoolYear=2020

      //  console.log(`Getting Intialisation data from : ${CalDetailsURL}`);

      const cache = localStorage.getItem(CalDetailsURL);
      let o;
      if (cache) {
        o = JSON.parse(cache);
      }

      if (o && Date.now() <= o.expires) {
        this.SetupCalData(o.data);

        //console.log(o.data);
      } else {
        //console.log("getting data from web");

        fetch(CalDetailsURL)
          .then((response) => response.json())
          .then((data) => {
            //   console.log(data);

            this.SetupCalData(data);

            localStorage.setItem(
              CalDetailsURL,
              JSON.stringify({
                expires: Date.now() + 60 * 60 * 24 * 1000, // Cache for 24 hours
                data: data,
              })
            );
          });
      }
    },
    SetupCalData(data) {
      if (data == null) {
        //  console.log("Dates not available");
        this.CalendarDates = [];
      } else if (data.CalendarDates == null) {
        //  console.log("Dates not available");
        this.CalendarDates = [];
      } else {
        //   console.log(data.CalendarDates[0]);

        this.CalendarDates = data.CalendarDates[0];
        //  console.log(this.CalendarDates);
        this.CalendarApprovedDate = data.CalendarApprovedDate;
        this.IsSchoolCalendarAvailable = this.CalendarDates.length == 0 ? false : true;


        this.TotalRegularDays = data.CalendarTotals.filter(function (total) {
          return total.Attendance == "TotalRegularFullAttendance";
        })[0].DayCount;

        this.TotalSummerDays = data.CalendarTotals.filter(function (total) {
          return total.Attendance == "SummerRegularAttendance";
        })[0].DayCount;

        this.TotalApprovedRegularDays = data.CalendarTotals.filter(function (
          total
        ) {
          return total.Attendance == "TotalApprovedRegularFullAttendance";
        })[0].DayCount;

        this.TotalApprovedSummerDays = data.CalendarTotals.filter(function (
          total
        ) {
          return total.Attendance == "ApprovedSummerRegularAttendance";
        })[0].DayCount;
      }
    },
    ////

    toggleCalendarInfo() {
      this.ShowCalendarInformation = !this.ShowCalendarInformation;

      if (this.ShowCalendarInformation) {
        this.getCalendarInfo();
      }
    },
    FormattedDate: function (date) {
      return date == null ? "" : moment(date).format("M/DD/YYYY");
    },
  },
  mounted() {
    //$('[data-toggle="tooltip"]').tooltip()
  },
  computed: {
    ApprovedCalendar() {
      if (this.SearchResult.CalendarApprovedDate != null) {
        return moment(this.SearchResult.CalendarApprovedDate).format(
          "M/DD/YYYY"
        );
      }
      return "";
    },
    IsAllowPast22() {
      //  console.log(this.Program.AssignedConsultant);
      if (this.Program.AllowPastAge22 != null) {
        return this.Program.AllowPastAge22 ? "Yes" : "No";
      }
      return "";
    },
    ShowDetailsRow() {
      return (
        this.ShowProgramInformation ||
        this.ShowRateInformation ||
        this.ShowCalendarInformation
      );
    },
    GoogleAddress() {
      return (
        "https://www.google.com/maps/place/" + this.SearchResult.ProgramAddress
      );
    },
    FacilityDisplayLink() {
      return (
        "/facility/" +
        this.SearchResult.SchoolYear +
        "/" +
        this.SearchResult.ProgramCode
      );
    },
    ElectronicCalendarLink() {
      return (
        "/pfsearch/calendar/" +
        this.SearchResult.SchoolYear +
        "/" +
        this.SearchResult.ProgramCode
      );

      // return (
      //   "https://apps.isbe.net/FacilityInquiry/UtilityPage/PFCalendar.aspx?SchoolYear=" +
      //   this.SearchResult.SchoolYear +
      //   "&ProgramId=" +
      //   this.SearchResult.ProgramCode
      // );
    },
    LimitedApprova() {
      //console.log(this.Program.AllowNewPlacements);
      if (this.Program.AllowNewPlacements) {
        return "Not Limited";
      }
      return "New Placements Not Allowed";
    },

    RegularBeginDate_SchoolCalendar() {
      if (this.CalendarDates.RegularBeginDate != null) {
        return moment(this.CalendarDates.RegularBeginDate).format("M/DD/YYYY");
      }
      return "";
    },
    RegularEndDate_SchoolCalendar() {
      if (this.CalendarDates.RegularEndDate != null) {
        return moment(this.CalendarDates.RegularEndDate).format("M/DD/YYYY");
      }
      return "";
    },
    SummerBeginDate_SchoolCalendar() {
      if (this.CalendarDates.SummerBeginDate != null) {
        return moment(this.CalendarDates.SummerBeginDate).format("M/DD/YYYY");
      }
      return "";
    },
    SummerEndDate_SchoolCalendar() {
      if (this.CalendarDates.SummerEndDate != null) {
        return moment(this.CalendarDates.SummerEndDate).format("M/DD/YYYY");
      }
      return "";
    },

    RegularBeginDate_Reimbursement() {
      if (this.CalendarDates.ApprovedRegularBeginDate != null) {
        return moment(this.CalendarDates.ApprovedRegularBeginDate).format(
          "M/DD/YYYY"
        );
      }
      return "";
    },
    RegularEndDate_Reimbursement() {
      if (this.CalendarDates.ApprovedRegularEndDate != null) {
        return moment(this.CalendarDates.ApprovedRegularEndDate).format(
          "M/DD/YYYY"
        );
      }
      return "";
    },
    SummerBeginDate_Reimbursement() {
      if (this.CalendarDates.ApprovedSummerBeginDate != null) {
        return moment(this.CalendarDates.ApprovedSummerBeginDate).format(
          "M/DD/YYYY"
        );
      }
      return "";
    },
    SummerEndDate_Reimbursement() {
      if (this.CalendarDates.ApprovedSummerEndDate != null) {
        return moment(this.CalendarDates.ApprovedSummerEndDate).format(
          "M/DD/YYYY"
        );
      }
      return "";
    },
  },
};
</script>
<style scoped>
.pf-table {
  width: 100%;
}
.pf-ghost-div {
  border-radius: 8px !important;
  border: 4px solid #e2eaee;
  background-color: ghostwhite;
}
.pf-no-border {
  border: none !important;
}
.icoLink {
  color: #006185 !important;
}

.hide {
  display: none;
}

.Program:hover .hide {
  display: inline;
}
a:hover {
  color: #00cd00 !important;
  text-decoration: none;
}
</style>